import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WorkloadClient } from '@internal/workload-api-helper';
import { Grid, Link, Typography, TextField } from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller, useFormContext } from 'react-hook-form';
import { useMemo } from 'react';

import { CustomTooltip, useStyles } from '../CustomTooltip';
import { CatalogFormInputProps } from '../types';
import { validateQuestion } from '../utils/checks';

export function CostCenter(props: CatalogFormInputProps) {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const oauthApi = useApi(microsoftAuthApiRef);
  const { control } = useFormContext();

  const workloadClient = useMemo(
    () => new WorkloadClient(configApi, oauthApi),
    [configApi, oauthApi],
  );

  return (
    <Grid container style={{ padding: 5 }} justifyContent="space-between">
      <Grid item xs={11}>
        <Controller
          name="pfg_cost_center"
          control={control}
          rules={{
            required: 'Cost center is required',
            validate: async value => {
              return await validateQuestion(
                'pfg_cost_center',
                value,
                props.apiValidation,
                workloadClient,
                false,
                true,
              );
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <Autocomplete
              {...field}
              options={props.costCenters || []}
              disabled={props.disabled}
              freeSolo
              renderInput={params => (
                <TextField
                  {...params}
                  label="Cost center"
                  variant="outlined"
                  fullWidth
                  required
                  error={!!error}
                  helperText={error?.message}
                  className={classes.root}
                />
              )}
              onChange={(_, newValue) => field.onChange(newValue)}
            />
          )}
        />
      </Grid>
      <Grid container item xs={1} alignItems="center">
        <CustomTooltip
          detail={
            <Typography variant="body1">
              See the{' '}
              <Link
                target="_blank"
                href="https://portal.developer.principal.com/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/aws-infrastructure/tagging/enterprise-tags/#pfg-cost-center"
              >
                tagging standards
              </Link>{' '}
              for more details.
            </Typography>
          }
        />
      </Grid>
    </Grid>
  );
}
